import { Box } from "@mui/material"
import constants from "../../../../constants"

const BackOrderedItemMessage = () => {
  return (
    <Box>
      <Box sx={{ marginBottom: '12px' }}>Items on backorder will ship once available.</Box>
      <Box>For more information on national drug shortages, visit:</Box>
      <ul>
        <li>
          <a className="text-info" href= "http://www.ashp.org/shortages" target ="_blank">www.ashp.org/shortages</a>
        </li>
        <li>
          <a className="text-info" href= "http://www.accessdata.fda.gov/scripts/drugshortages" target ="_blank">www.accessdata.fda.gov/scripts/drugshortages</a>
        </li>
      </ul>
      For questions, call {constants.HEALTHFIRST_COMPANY_SHORT_NAME} customer support at {constants.HEALTHFIRST_PHONE_NUMBER}
    </Box>        
  )
}

export default BackOrderedItemMessage
